import { SubTableColumn } from 'src/components/commons/subTable/types';

const COLUMNS: SubTableColumn[] = [
  {
    key: '',
    title: 'PRODUCT FAMILY NAME',
    dataIndex: 'name',
    editable: true,
    minWidth: 270,
    dataType: 'string',
    unique: true,
    required: true,
    hidden: false,
    dataStructure: 'string',
    headerName: 'Product Family',
    options: [],
    orderField: 'name',
    searchField: 'name',
  },
];

export default COLUMNS;
